/**
 * Whether authorization changes can be requested in the given context.
 * Checks the FSP config: enabled flag + whether the context role is in the allowed roles.
 *
 * @param {object} authorization - The service authorization object
 * @param {string} contextRole - The role representing the current context
 *                               ('utilization_manager' or 'case_manager')
 * @returns {boolean}
 */
const canRequestAuthorizationChange = (authorization, contextRole) => {
  const fsp = authorization?.fee_schedule_program;
  if (!fsp?.auth_change_request_enabled) return false;

  const allowedRoles = fsp.auth_change_request_allowed_roles || [];
  return allowedRoles.includes(contextRole);
};

export default canRequestAuthorizationChange;
